// Import model
import { DataviewLead2Response } from '../models/DataviewLead2Response';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterLead2Request } from '../models/FilterLead2Request';
import { Lead2 } from '../models/Lead2';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterLead2RequestSerializer } from './FilterLead2RequestSerializer';
import { Lead2Serializer } from './Lead2Serializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewLead2Response - handles JSON serialization and deserialization with type validation
 */
export class DataviewLead2ResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewLead2Response instance
   */
  static deserialize(json: string): DataviewLead2Response {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewLead2Response instance
   */
  static fromObject(obj: any): DataviewLead2Response {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewLead2Response');
    }


    const instance: DataviewLead2Response = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        Lead2Serializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterLead2RequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewLead2Response instances
   */
  static deserializeArray(json: string): DataviewLead2Response[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewLead2Response instance to a JSON string
   */
  static serialize(instance: DataviewLead2Response): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewLead2Response instance to a plain object
   */
  static toObject(instance: DataviewLead2Response): any {
    return {
      'Result': instance.result?.map((item: any) =>
        Lead2Serializer.toObject(item)
      ),
      'Request': instance.request ? FilterLead2RequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewLead2Response instances to a JSON string
   */
  static serializeArray(instances: DataviewLead2Response[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
